import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppService, CoreTypes, LabelValue } from 'common-cloudstudio';

@Component({
  selector: 'app-incident-filters',
  templateUrl: './incident-filters.component.html',
  styleUrls: ['./incident-filters.component.scss'], 
})

export class IncidentFiltersComponent implements OnInit, OnChanges {
  @Input() enableExportButton: boolean = false;
  @Input() enableCleanButton: boolean = false;
  @Input() params: CoreTypes.FormParameter[] = [];
  @Input() enabledDropdownButton: boolean;
  @Input() menuButtonList: LabelValue<any>[] = [];

  @Input() customButton1Text: string;
  @Input() customButton2Text: string;
  @Input() customButton3Text: string;
  @Input() customButton4Text: string;
  @Input() customButton5Text: string;

  @Input() customButton1Disabled: boolean;
  @Input() customButton2Disabled: boolean;
  @Input() customButton3Disabled: boolean;
  @Input() customButton4Disabled: boolean;
  @Input() customButton5Disabled: boolean;
  
  @Input() customButton1Tooltip: boolean;
  @Input() customButton2Tooltip: boolean;
  @Input() customButton3Tooltip: boolean;
  @Input() customButton4Tooltip: boolean;
  @Input() customButton5Tooltip: boolean;

  @Output() onCustomButton1 = new EventEmitter();
  @Output() onCustomButton2 = new EventEmitter();
  @Output() onCustomButton3 = new EventEmitter();
  @Output() onCustomButton4 = new EventEmitter();
  @Output() onCustomButton5 = new EventEmitter();

  @Output() onActionBtnList = new EventEmitter();


  _params = [];
  _exceptionMessage: string = '';
  _mustExecuteReport: boolean = false;
  enableCleanFilter: boolean = false;
  _exportFormats: Array<CoreTypes.ReportFileType> = new Array(CoreTypes.ReportFileType.CSV, CoreTypes.ReportFileType.PDF);
  menuButtonSelect: LabelValue<number>;
  
  constructor(public _appService: AppService) { }
  
  ngOnInit(): void {
 
   }

  ngOnChanges(data: SimpleChanges): void {
    if(data?.params?.currentValue) {
      this._params = this.params;
    }
  } 

  execReport(myForm: any, downloadEvent: any, noLoad?:boolean) {

  }
  cleanAllData() {

  }
  resetParams() {

  }
  expand() {
    
  }

  onCustomButtonClick($event, type?: string) {
    switch (type) {
      case 'onCustomButton1':
        this.onCustomButton1.emit($event);
          break;
      case 'onCustomButton2':
        this.onCustomButton2.emit($event);
          break;
      case 'onCustomButton3':
        this.onCustomButton3.emit($event);
          break;
      case 'onCustomButton4':
        this.onCustomButton4.emit($event);
          break;
      case 'onCustomButton4':
        this.onCustomButton5.emit($event);
          break;
      default:
          break;
    }
  }

  action(event?: any){
    if (event) event.preventDefault();
    this.onActionBtnList.emit(this.menuButtonSelect);
  }

  onDisabledClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
  
}
